/**
 * Centrale versie configuratie voor de SuperKonnected Community App
 * 
 * Update dit bestand bij elke nieuwe release.
 * Dit is de single source of truth voor versie-informatie.
 */

type ReleaseStage = 'alpha' | 'beta' | 'rc' | 'stable';

export const APP_VERSION = {
  /** Major version - grote wijzigingen, breaking changes */
  major: 2,
  /** Minor version - nieuwe features, backwards compatible */
  minor: 0,
  /** Patch version - bug fixes */
  patch: 0,
  /** Release stage: 'alpha' | 'beta' | 'rc' | 'stable' */
  stage: 'beta' as ReleaseStage,
  /** Volledige versie string (semver) */
  full: '2.0.0-beta',
  /** Display versie voor UI */
  display: 'v2.0 BETA',
  /** Korte versie voor badges */
  short: 'BETA 2.0',
  /** Release datum van deze versie */
  releaseDate: '2026-02-06',
  /** Verwachte stable release datum */
  expectedStableDate: '2026-03-31',
};

/** Helper om te checken of we in beta zijn */
export const isBeta = () => APP_VERSION.stage === 'beta';

/** Helper om te checken of we in stable zijn */
export const isStable = () => APP_VERSION.stage === 'stable';

export default APP_VERSION;
